import {BLOG_DIR} from '@/lib/env'
import {match} from 'ts-pattern'

export default function resolveSlug({
  _type,
  internal,
  params,
  external,
}: {
  // internal
  _type?: string
  internal?: string
  params?: string
  // external
  external?: string
}) {
  if (external) return external

  if (internal) {
    const segment = match(_type)
      .with('blog.post', 'blog.video', 'blog.category-cluster', () => `/${BLOG_DIR}/`)
      .with('blog.category', () => '/category/')
      .with('blog.tag', () => '/tag/')
      .otherwise(() => '/')

    const path = internal === 'index' ? null : internal

    return [segment, path, params].filter(Boolean).join('')
  }

  return undefined
}
